module.exports = __webpack_public_path__ + "img/sale_setting.3e0ddd66.png";